import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyCS() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Zpět do aplikace
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Zásady ochrany osobních údajů</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Správce osobních údajů</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Správcem osobních údajů je:</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Název:</strong> Puretech s.r.o.</p>
                  <p><strong>IČO:</strong> 05503795</p>
                  <p><strong>Sídlo:</strong> Česká republika</p>
                  <p><strong>Kontakt:</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informace, které shromažďujeme</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Informace o účtu:</strong> Když si vytvoříte účet, shromažďujeme vaši e-mailovou adresu a případné profilové informace, které se rozhodnete poskytnout.
                </p>
                <p className="leading-relaxed">
                  <strong>Údaje o používání:</strong> Shromažďujeme informace o tom, jak používáte naši službu, včetně vytvořených úkolů, spravovaných projektů a vzorců používání funkcí.
                </p>
                <p className="leading-relaxed">
                  <strong>Platební informace:</strong> Zpracování plateb zajišťuje Polar. Údaje o vaší platební kartě neukládáme na našich serverech.
                </p>
                <p className="leading-relaxed">
                  <strong>Technické údaje:</strong> Automaticky shromažďujeme určité technické informace, včetně IP adresy, typu prohlížeče, operačního systému a informací o zařízení.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Jak používáme vaše informace</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Shromážděné informace používáme k:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Poskytování, udržování a zlepšování našich služeb</li>
                  <li>Zpracování transakcí a správě předplatných</li>
                  <li>Zasílání technických oznámení a podpůrných zpráv</li>
                  <li>Odpovědi na vaše komentáře a otázky</li>
                  <li>Analýze vzorců použití pro zlepšení uživatelské zkušenosti</li>
                  <li>Vymáhání našich obchodních podmínek</li>
                  <li>Dodržování právních povinností</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Sdílení informací</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Neprodáváme, neobchodujeme ani jinak nepředáváme vaše osobní údaje třetím stranám s výjimkou případů popsaných v těchto zásadách:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Poskytovatelé služeb:</strong> Můžeme sdílet informace s důvěryhodnými třetími stranami, které nám pomáhají provozovat naši službu (např. Polar pro zpracování plateb, Supabase pro databázové služby)</li>
                  <li><strong>Právní požadavky:</strong> Můžeme zveřejnit informace, pokud to vyžaduje zákon nebo k ochraně našich práv</li>
                  <li><strong>Převody firmy:</strong> V případě fúze, akvizice nebo prodeje aktiv mohou být uživatelské informace převedeny</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Zabezpečení údajů</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Implementujeme vhodná technická a organizační bezpečnostní opatření k ochraně vašich osobních údajů proti neoprávněnému přístupu, změně, zveřejnění nebo zničení. Žádný způsob přenosu přes internet však není 100% bezpečný.
                </p>
                <p className="leading-relaxed">
                  <strong>Narušení zabezpečení:</strong> V případě porušení zabezpečení osobních údajů budeme postupovat v souladu s GDPR:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Ohlásíme incident příslušnému dozorovému úřadu do 72 hodin od zjištění</li>
                  <li>Budeme vás informovat, pokud by porušení mohlo představovat vysoké riziko pro vaše práva a svobody</li>
                  <li>Podnikneme kroky k minimalizaci dopadu a předcházení budoucím incidentům</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Uchovávání údajů</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Vaše osobní údaje uchováváme tak dlouho, jak je nutné k poskytování našich služeb. Konkrétní doby uchovávání jsou:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Údaje o účtu:</strong> Po dobu trvání vašeho účtu + 30 dní po smazání účtu</li>
                  <li><strong>Obsah úkolů (sticky notes):</strong> Dokud je nesmažete nebo nezrušíte účet</li>
                  <li><strong>Platební záznamy:</strong> 7 let (požadavek českého účetního zákona č. 563/1991 Sb.)</li>
                  <li><strong>Analytické údaje:</strong> Až 26 měsíců</li>
                  <li><strong>Záložní data:</strong> Mohou přetrvávat až 90 dní po primárním smazání</li>
                  <li><strong>Anonymizovaná data:</strong> Uchováváme trvale pro statistické účely</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Vaše práva podle GDPR</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Máte právo na:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Přístup k osobním údajům, které o vás uchováváme</li>
                  <li>Opravu jakýchkoli nepřesných osobních údajů</li>
                  <li>Žádost o smazání vašich osobních údajů</li>
                  <li>Námitku nebo omezení zpracování vašich údajů</li>
                  <li>Přenositelnost údajů (obdržet kopii vašich dat ve strukturovaném formátu)</li>
                  <li>Kdykoli odvolat souhlas</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Soubory cookie a sledování</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Používáme soubory cookie a podobné sledovací technologie ke zlepšení vaší zkušenosti. Typy cookies, které používáme:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Nezbytné cookies:</strong> Potřebné pro fungování služby (přihlášení, autentizace)</li>
                  <li><strong>Analytické cookies:</strong> Pomáhají nám pochopit, jak používáte naši službu (můžete odmítnout)</li>
                  <li><strong>Cookies třetích stran:</strong> Google OAuth, Polar pro platby</li>
                </ul>
                <p className="leading-relaxed">
                  Nastavení cookies můžete ovládat prostřednictvím preferencí svého prohlížeče nebo našeho cookie banneru při první návštěvě.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Služby třetích stran</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Naše služba se integruje se službami třetích stran:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth:</strong> Pro autentizaci (podléhá zásadám ochrany osobních údajů společnosti Google)</li>
                  <li><strong>Polar:</strong> Pro zpracování plateb (podléhá zásadám ochrany osobních údajů společnosti Polar)</li>
                  <li><strong>Supabase:</strong> Pro databázové a autentizační služby</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Ochrana soukromí dětí</h2>
              <p className="leading-relaxed">
                Naše služba není určena pro děti mladší 16 let. Vědomě neshromažďujeme osobní údaje od dětí mladších 16 let. Pokud jste rodič nebo opatrovník a věříte, že nám vaše dítě poskytlo osobní údaje, kontaktujte nás prosím na support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Mezinárodní přenosy údajů</h2>
              <p className="leading-relaxed">
                Vaše informace mohou být převedeny do a zpracovávány v zemích jiných než vaše země bydliště. Zajišťujeme, že jsou zavedeny vhodné záruky na ochranu vašich osobních údajů v souladu s příslušnými zákony o ochraně údajů.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Změny těchto zásad</h2>
              <p className="leading-relaxed">
                Tyto zásady ochrany osobních údajů můžeme čas od času aktualizovat. O jakýchkoli podstatných změnách vás budeme informovat zveřejněním nových zásad na této stránce a aktualizací data "Poslední aktualizace".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Automatizované rozhodování</h2>
              <p className="leading-relaxed">
                Naše služba používá AI algoritmus pro generování návrhů úkolů. Tato funkce je čistě pomocná a nevytváří žádná rozhodnutí, která by měla právní nebo významné důsledky pro uživatele. Můžete se kdykoli rozhodnout návrhy nepoužívat.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Dozorový úřad</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Máte právo podat stížnost u dozorového úřadu pro ochranu osobních údajů:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Úřad pro ochranu osobních údajů (ÚOOÚ)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Praha 7</p>
                  <p className="text-sm">Web: <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">E-mail: posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Jak uplatnit svá práva</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Pro uplatnění vašich práv podle GDPR (přístup k datům, oprava, mazání, přenositelnost, námitka atd.):
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Zašlete nám žádost na <strong>support@simplestickers.app</strong></li>
                  <li>Odpovíme do <strong>1 měsíce</strong> od obdržení žádosti</li>
                  <li>Můžeme požádat o ověření vaší identity</li>
                  <li>Služba je <strong>bezplatná</strong> (pokud žádost není zjevně nepodložená nebo nadměrná)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Kontaktujte nás</h2>
              <p className="leading-relaxed">
                Pokud máte nějaké otázky ohledně těchto zásad ochrany osobních údajů nebo našich postupů zacházení s údaji, kontaktujte nás:
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>E-mail:</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Pro všechny otázky týkající se ochrany soukromí, žádostí o data, podpory a ostatních dotazů
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
